import { filtersFormController, translate } from 'magner';
import { ISuggestion } from 'features/profile/safety/suggestions/types';

const suggestionsFilters = filtersFormController<ISuggestion>({
  actions: [],

  saveToLocalStorage: true,

  submitEvent: 'input',

  pagination: {
    items: 25,
    page: 1,
  },
  filtersInSeparatePanel: false,
  filtersData: {
    text: '',
  },
  sort: {},

  layout: [{
    type: 'input',
    name: 'text',
    props: {
      placeholder: translate('gaz.safety.filters.text'),
      inputDelay: 250,
    },
  }],
});

export default suggestionsFilters;
